import { render, staticRenderFns } from "./MachineDefect.vue?vue&type=template&id=5b9c2b23&scoped=true&"
import script from "./MachineDefect.vue?vue&type=script&lang=js&"
export * from "./MachineDefect.vue?vue&type=script&lang=js&"
import style0 from "./MachineDefect.vue?vue&type=style&index=0&id=5b9c2b23&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9c2b23",
  null
  
)

export default component.exports